export default __webpack_public_path__ + "static/media/avatar_5.765f5d34.png";